import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShareArrowDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="share-arrow-down, save"><path d="M8.5 11.5L12 15L15.5 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 14V1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.75 4.75H20.25V20.25H3.75V4.75H7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShareArrowDown;
